import { render, staticRenderFns } from "./CideCombustivel.vue?vue&type=template&id=a1f5d982&scoped=true&"
import script from "./CideCombustivel.vue?vue&type=script&lang=js&"
export * from "./CideCombustivel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f5d982",
  null
  
)

export default component.exports